import { all, call, put, takeLatest } from "redux-saga/effects";
import * as api from "src/api/subscription";
import * as actions from "src/redux/actions/subscriptionAction";

function* fetchPlans(
  action: ReturnType<typeof actions.fetchPlans.request>
): Generator<any, void, any> {
  try {
    const plans = yield call(api.getAllSubscriptionPlans, action.payload.username);
    yield put(actions.fetchPlans.success(plans));
  } catch (err) {
    yield put(actions.fetchPlans.failure(err as Error));
  }
}

function* fetchUserSubs(
  action: ReturnType<typeof actions.fetchUserSubscriptions.request>
): Generator<any, void, any> {
  try {
    const subs = yield call(api.getUserSubscriptions, action.payload.username);
    yield put(actions.fetchUserSubscriptions.success(subs));
  } catch (err) {
    yield put(actions.fetchUserSubscriptions.failure(err as Error));
  }
}

function* createSub(
  action: ReturnType<typeof actions.createSubscription.request>
): Generator<any, void, any> {
  const { username, payload } = action.payload;
  try {
    const { subscriptionId, short_url } = yield call(api.createUserSubscription, username, payload);
    yield put(actions.createSubscription.success({ subscriptionId, short_url }));
  } catch (err) {
    yield put(actions.createSubscription.failure(err as Error));
  }
}

function* deleteSub(
  action: ReturnType<typeof actions.deleteSubscription.request>
): Generator<any, void, any> {
  const { username, subscriptionId } = action.payload;
  try {
    yield call(api.deleteUserSubscription, username, subscriptionId);
    yield put(actions.deleteSubscription.success(subscriptionId));
  } catch (err) {
    yield put(actions.deleteSubscription.failure(err as Error));
  }
}

/* ---------- watchers ---------- */

export default function* subscriptionSaga() {
  yield all([
    takeLatest(actions.fetchPlans.request, fetchPlans),
    takeLatest(actions.fetchUserSubscriptions.request, fetchUserSubs),
    takeLatest(actions.createSubscription.request, createSub),
    takeLatest(actions.deleteSubscription.request, deleteSub)
  ]);
}
